import { Model } from "vue-mc";

export class Massupdate extends Model {
  defaults() {
    return {
      vendor: null
      , dateresini: null
      , dateresend: null
      , datelimini: null
      , datelimend: null
      , cuotasimple: null
      , benefpref: null
      , contactpref: null
      , oob: null
      , status: null
    };
  }

  mutations() {
    return {
      vendor: (vendor) => vendor
      , dateresini: (dateresini) => dateresini
      , dateresend: (dateresend) => dateresend
      , datelimini: (datelimini) => datelimini
      , datelimend: (datelimend) => datelimend
      , cuotasimple: (cuotasimple) => cuotasimple
      , benefpref: (benefpref) => benefpref
      , contactpref: (contactpref) => contactpref
      , oob: (oob) => oob
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/massupdate.js